<template>
  <div id="August2024" class="202408">
    <div>
      <img src="~@/assets/images/202408/head.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202408/m/head.png" class="object-contain mx-auto md:hidden">
    </div>
    <div>
      <div><img src="~@/assets/images/202408/con1-tittle.png" class="object-contain mx-auto"></div>
      <div class="flex justify-center flex-wrap md:flex-no-wrap">
        <div class="p-2 w-1/2 md:w-auto"><img src="~@/assets/images/202408/con1-1y.png" class="object-contain mx-auto"></div>
        <div class="p-2 w-1/2 md:w-auto"><img src="~@/assets/images/202408/con1-2y.png" class="object-contain mx-auto"></div>
        <div class="p-2 w-1/2 md:w-auto"><img src="~@/assets/images/202408/con1-3y.png" class="object-contain mx-auto"></div>
        <div class="p-2 w-1/2 md:w-auto"><img src="~@/assets/images/202408/con1-extra.png" class="object-contain mx-auto"></div>
      </div>
    </div>
    <section class="main mx-auto main-bg-yellow py-6 md:py-12 p-2">
      <div class="plan1 max-w-6xl bg-white mx-auto rounded-2xl overflow-hidden mb-6">
        <div class="flex flex-wrap justify-center p-2 md:p-10">
          <div class="w-4/5"><img src="~@/assets/images/202408/mag-hiw.png" class="object-contain mx-auto"></div>
          <div class="w-1/5"><img src="~@/assets/images/202408/con1-img.png" class="object-contain mx-auto"></div>
          <div class="w-full"><img src="~@/assets/images/202408/mag-abc.png" class="object-contain mx-auto"></div>
          <div class="p-2 w-1/4"><img src="~@/assets/images/202408/mag-live.png" class="object-contain mx-auto"></div>
          <div class="p-2 w-1/4"><img src="~@/assets/images/202408/mag-all.png" class="object-contain mx-auto"></div>
          <div class="p-2 w-1/4"><img src="~@/assets/images/202408/mag-cnn.png" class="object-contain mx-auto"></div>
          <div class="p-2 w-1/4"><img src="~@/assets/images/202408/mag-jp.png" class="object-contain mx-auto"></div>
        </div>

        <a href="https://store.liveabc.com/products/recent/sale?tag=386" target="_blank" class="block w-full text-white text-lg md:text-xl order-bg p-3 md:p-6 text-center">我要訂閱</a>
      </div>
      <div class="plan2 max-w-6xl mx-auto">
        <div class="flex justify-center">
          <div class="md:-ml-16 z-10 hidden md:block"><img src="~@/assets/images/202408/con2-img.png" class="object-contain mx-auto"></div>
          <div class="flex items-end md:-ml-20">
            <div><img src="~@/assets/images/202408/con2-tittle.png" class="object-contain mx-auto"></div>
            <div class="md:pb-8 -ml-10 md:-ml-2 -mb-6 md:-mb-0"><img src="~@/assets/images/202408/book2.png" class="object-contain mx-auto"></div>
            <div class="md:pb-8 -ml-2 md:-ml-2 -mb-6 md:-mb-0"><img src="~@/assets/images/202408/book1.png" class="object-contain mx-auto"></div>
          </div>
        </div>

        <div class="flex flex-wrap w-full items-center">
          <div class="w-2/3 md:w-1/4 p-2 md:hidden"><img src="~@/assets/images/202408/con2-img.png" class="object-contain mx-auto"></div>
          <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="w-1/3 md:w-1/4 p-2" v-for="(item, index) in bookData1" :key="index"><img :src="item.img_url" class="object-contain mx-auto"></router-link>
        </div>

        <a href="https://store.liveabc.com/products/magazine/sale?tag=397" target="_blank" class="block w-full text-white text-lg md:text-xl order-bg p-3 md:p-6 text-center rounded-b-2xl">更多介紹</a>
      </div>
      <div class="plan3 max-w-6xl mx-auto p-2">
        <div class="">
          <img src="~@/assets/images/202408/con3-head.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202408/m/con3.png" class="object-contain mx-auto md:hidden">
        </div>
        <div class="flex flex-wrap w-full justify-center p-2">
          <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="w-1/3 md:w-1/4 p-2" v-for="(item, index) in bookData2" :key="index"><img :src="item.img_url" class="object-contain mx-auto"></router-link>
        </div>
        <a href="https://store.liveabc.com/products/magazine/sale?tag=398" target="_blank"  class="block w-full text-white  text-lg md:text-xl order-bg p-3 md:p-6 text-center rounded-b-2xl">更多介紹</a>
      </div>

      <div class="plan4 max-w-6xl mx-auto">
        <a class="block" href="https://store.liveabc.com/products/magazine/sale?tag=399" target="_blank">
          <img src="~@/assets/images/202408/con4.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202408/m/con4.png" class="object-contain mx-auto md:hidden">
        </a>
      </div>
    </section>

    <div class="footer py-8 md:py-10">
      <p class="md:text-lg text-center tracking-wider mb-4 md:mb-6 px-12 md:px-0 text-white">活動內容以LiveABC官網發布為主。<span class="md:hidden"><br/></span>本公司保留活動修改、變更之權利。</p>
      <router-link :to="{ name: 'index' }" class="">
        <img src="~@/assets/images/202408/bt-web.png" class="object-contain mx-auto">
      </router-link>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'June2024',
  metaInfo () {
    return {
      title: 'LiveABC新學期大降價 全產品優惠中!',
      titleTemplate: null
    }
  },
  data () {
    return {
      bookData1: [
        { id: 7694, img_url: require('@/assets/images/202408/p1/item1.png') },
        { id: 6935, img_url: require('@/assets/images/202408/p1/item2.png') },
        { id: 7458, img_url: require('@/assets/images/202408/p1/item3.png') },
        { id: 9534, img_url: require('@/assets/images/202408/p1/item4.png') },
        { id: 8588, img_url: require('@/assets/images/202408/p1/item5.png') },
        { id: 9524, img_url: require('@/assets/images/202408/p1/item6.png') },
        { id: 9108, img_url: require('@/assets/images/202408/p1/item7.png') },
        { id: 9317, img_url: require('@/assets/images/202408/p1/item8.png') },
        { id: 8926, img_url: require('@/assets/images/202408/p1/item9.png') },
        { id: 8465, img_url: require('@/assets/images/202408/p1/item10.png') },
        { id: 7399, img_url: require('@/assets/images/202408/p1/item11.png') },
        { id: 8214, img_url: require('@/assets/images/202408/p1/item12.png') },
        { id: 7287, img_url: require('@/assets/images/202408/p1/item13.png') },
        { id: 8461, img_url: require('@/assets/images/202408/p1/item16.png') },
        { id: 9601, img_url: require('@/assets/images/202408/p1/item15.png') },
        { id: 7582, img_url: require('@/assets/images/202408/p1/item14.png') }
      ],
      bookData2: [
        { id: 7549, img_url: require('@/assets/images/202408/p2/item3.png') },
        { id: 7873, img_url: require('@/assets/images/202408/p2/item4.png') },
        { id: 7093, img_url: require('@/assets/images/202408/p2/item5.png') },
        { id: 8627, img_url: require('@/assets/images/202408/p2/item6.png') },
        { id: 6215, img_url: require('@/assets/images/202408/p2/item7.png') },
        { id: 8134, img_url: require('@/assets/images/202408/p2/item8.png') },
        { id: 7455, img_url: require('@/assets/images/202408/p2/item.png') },
        { id: 8738, img_url: require('@/assets/images/202408/p2/item2.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#August2024 {
  background-color: #fbf288;
  .order-bg {
    background-color: #282828;
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .footer {
    background-color: #FAA950;
  }
}
</style>
